/**
 * ExpertProfile.js - Page profil Expert
 * Utilise le composant ProfilePageModern unifié
 */
import React from 'react';
import ProfilePageModern from './ProfilePageModern';

export default function ExpertProfile() {
  return <ProfilePageModern userType="expert" />;
}
